import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment from 'moment';
import {ApiContactHistory, formatDatum} from './ContactHistory';
import {useSettings} from '@/store/settings';
import {ProviderStatus} from './Provider';
import pinia from '@/plugins/pinia';

export interface ApiFollowup extends ApiContactHistory {
  KundStatus: string;
  Bediener: [
    {
      Gelesen: {
        Status: boolean;
        Datum: any | null;
        GesetztDurchBediener: any | null;
      };
      Erledigt: {
        Status: boolean;
        Datum: any | null;
        GesetztDurchBediener: any | null;
      };
      KundenNr: number;
      AnsprechNr: any | null;
      LfdNr: number;
      Bediener: string | 'SYS';
      WiedervorlageDatum: string;
      WiedervorlageUhrzeit: string;
    }
  ];
}

export interface FollowupFilters {
  KundStatus$In?: ProviderStatus[];
  Erledigt?: boolean;
  Fulltext$Fulltext: FulltextSearch;
  Bediener$Any: {
    Bediener?: string | null
    'Erledigt/Status'?: boolean
    'Gelesen/Status'?: boolean
    WiedervorlageDatum$From?: string;
    WiedervorlageDatum$To?: string;
  }
  AnlageDatum$From?: string;
  AnlageDatum$To?: string;
}

export default class Followup extends autoImplement<ApiFollowup>() {
  static fromApi(apiFollowup: ApiFollowup): Followup {
    return new Followup(apiFollowup);
  }

  get currentBediener() {
    const short = useSettings(pinia).userShort;
    return this.Bediener.find((bediener) => bediener.Bediener === short);
  }

  get read() {
    return this.currentBediener?.Gelesen.Status ?? false;
  }
  get readIcon() {
    return this.read ? 'mdi-email-open-outline' : 'mdi-email-outline';
  }
  get readColor() {
    return this.read ? 'success' : 'error';
  }
  get typeIcon() {
    switch (this.Art) {
      case 'T': // Telefonat
        return 'mdi-phone';
      case 'AN': // Angebote
        return 'mdi-file-document';
      case 'AU': // Auftrag
        return 'mdi-file-document-check';
      case 'RE': // Rechnung
        return 'mdi-receipt-text';
      case 'EL': // Eingangslieferschein
        return 'mdi-truck-check';
    }
    return 'mdi-file-document';
  }
  get typeColor() {
    switch (this.KundStatus) {
      case ProviderStatus.EhemaligeKunden:
        return 'error';
      case ProviderStatus.Interessenten:
        return 'warning';
      case ProviderStatus.Lieferanten:
        return 'info';
      case ProviderStatus.Kunden:
        return 'success';
      default:
        return 'dark';
    }
  }
  get AnlageDatumFormatted() {
    const time = this.AnlageUhrzeit.split(':');
    return moment(this.AnlageDatum)
        .hour(Number(time[0]))
        .minute(Number(time[1]))
        .format('DD.MM.YYYY HH:mm');
  }
  get WiedervorlageDatumFormatted() {
    let date = this.currentBediener?.WiedervorlageDatum;
    let time = this.currentBediener?.WiedervorlageUhrzeit;

    if (!date && !time) {
      date = this.WiedervorlageDatum;
      time = this.WiedervorlageUhrzeit;
    }

    if (!date || !time) return 'Invalid Date';
    return formatDatum(date, time);
  }
  get AnsprechpartnerFormatted() {
    if (this.Ansprechpartner.length > 0) {
      return `${this.Ansprechpartner[0].Vorname} ${this.Ansprechpartner[0].Nachname}`;
    }
  }
}
